import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["nav", "button"]

  connect() {
    this.lastScrollY = window.scrollY
    this.onScroll = this.handleScroll.bind(this)
    window.addEventListener("scroll", this.onScroll, { passive: true })
    this.setActiveNav()
  }

  disconnect() {
    window.removeEventListener("scroll", this.onScroll)
  }

  toggle() {
    const isOpen = this.navTarget.classList.toggle("is-open")

    this.element.classList.toggle("is-menu-open", isOpen)
    this.buttonTarget.setAttribute("aria-expanded", String(isOpen))

    if (isOpen) {
      this.element.classList.remove("is-hidden")
    }
  }

  close() {
    this.navTarget.classList.remove("is-open")
    this.element.classList.remove("is-menu-open")
    this.buttonTarget.setAttribute("aria-expanded", "false")
  }

  handleScroll() {
    const currentScrollY = window.scrollY

    if (this.navTarget.classList.contains("is-open")) {
      this.lastScrollY = currentScrollY
      return
    }

    if (currentScrollY <= 0 || currentScrollY < this.lastScrollY) {
      this.element.classList.remove("is-hidden")
    } else if (currentScrollY > this.lastScrollY && currentScrollY > 80) {
      this.element.classList.add("is-hidden")
    }

    this.lastScrollY = currentScrollY
  }

  setActiveNav() {
    const currentPath = this.normalizePath(window.location.pathname)
    const links = this.element.querySelectorAll(".nav-link")

    links.forEach((link) => {
      const navPath = this.normalizePath(link.dataset.navPath)
      link.classList.toggle("active", currentPath === navPath)
    })
  }

  normalizePath(path) {
    if (!path) return "/"

    const stripped = path.replace(/index\.html$/i, "").replace(/\.html$/i, "")

    if (stripped === "" || stripped === "/") {
      return "/"
    }

    return stripped.endsWith("/") ? stripped.slice(0, -1) : stripped
  }
}
